import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const CatalystPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      // heroTitle="A Feature-Rich App Built for"
      // heroGradientText="Networking and Navigation"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      client="StartupTN Catalyst"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      logoStyle={styles.logo}
      clientLogo="/images/startup-white.png"
      infoLabel5="Website"
      visitWebsite="Visit Site"
      website="https://catalyst.startuptn.in/"
      overviewTitle="Overview"
      // approachTitle="Approach"
      heroImage="/images/catalyst-first.png"
      overviewImage="/images/catalyst-first.png"
      approachImage="/images/catalyst-full.png"
      overviewDescription={[
        'Catalyst is an integrated platform by StartupTN envisioned to accelerate Tamil Nadu’s innovation and entrepreneurship journey by empowering incubators, accelerators, and ecosystem enablers. Acting as a unified hub, Catalyst connects institutions, startups, mentors, and investors to build a robust support system that nurtures ideas from inception to market success. It serves as the driving force behind the state’s mission to strengthen the startup ecosystem, promote innovation-driven enterprises, and create sustainable economic impact.'
      ]}
      approachDescription={[
        'Tamil Nadu is home to the largest and most diversified network of incubation centres in India, and Catalyst plays a central role in integrating and uplifting this ecosystem. With over 120+ incubators across 30 districts, the state’s incubator network supports entrepreneurs through every stage — from ideation and proof-of-concept to scaling and commercialization. Catalyst amplifies this effort by providing digital access to resources, training programs, mentorship networks, funding opportunities, and ecosystem collaborations. Through this platform, StartupTN ensures that every aspiring innovator, regardless of geography, gains access to world-class incubation support and guidance.',
        'Catalyst also focuses on developing Pre-Incubation Centres (PICs) and Centres of Excellence (CoEs) across emerging sectors such as AgriTech, RuralTech, ClimateTech, and MarineTech. These centres create specialized environments for research, innovation, and entrepreneurship, fostering domain-specific growth. Additionally, StartupTN uses Catalyst to implement structured assessment frameworks like the Tamil Nadu Incubator Maturity Model, which evaluates and strengthens incubators based on performance and capability. By bringing together intellect, infrastructure, and investment under one digital roof, Catalyst truly accelerates Tamil Nadu’s vision of becoming a global hub for innovation, entrepreneurship, and inclusive growth.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      gradientTextStyle={styles.gradientText}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      // approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default CatalystPage;
